export interface Division {
    ClientKey?: string;
    Id: string;
    DivisionName: string;
    OrganizationId: string;
}
